// extracted by mini-css-extract-plugin
export var center = "_3s-2";
export var clickableRow = "_3s-5";
export var expandedRow = "_3s-7";
export var hoverable = "_3s-4";
export var left = "_3s-1";
export var right = "_3s-3";
export var row = "_3s-0";
export var selectedRow = "_3s-6";
export var summaryRow = "_3s-8";